import React from 'react';
import IconoFrontend from '../images/about/Frontend.png';
import IconoBackend from '../images/about/Backend.png';
import IconoWordpress from '../images/about/CMS.png';

import {
  AcercaDe,
  DivTitle,
  GridOverlay,
  AboutContainer,
  AboutContent,
  Title,
  Paragraph,
  ParagraphBold,
  DivConocimientos,
  ColumnsContainer,
  ColumnBox,
  AboutTitle,
  Espacio,
  TechsContainer,
  TechsTitle,
  TechsGrid
} from '../styles/about.styles';

const About = () => {
  return (
    <AcercaDe>
      <DivTitle>
        <GridOverlay />
        <AboutContainer>
          <AboutContent>
            <Title>Sobre mí</Title>
            <Paragraph>
              Soy un desarrollador fullstack apasionado por transformar problemas complejos en soluciones digitales ágiles. Combino rigor técnico, diseño intuitivo y enfoque de negocio para entregar software que no solo se ve bien, sino que genera resultados medibles.
            </Paragraph>

            <ParagraphBold style={{ fontWeight: 600 }}>
              ~ Transformo tus ideas en software funcional que hace crecer tu negocio.
            </ParagraphBold>
          </AboutContent>
        </AboutContainer>
      </DivTitle>

      <DivConocimientos>
        <ColumnsContainer>
          <ColumnBox>
            <figure className='image'>
              <img className='skill-icon' src={IconoFrontend} alt='Páginas Web y Landing Pages' />
            </figure>
            <AboutTitle>
              Páginas Web y Landing Pages
            </AboutTitle>
            <p>
              Sitios web modernos, rápidos y optimizados para convertir visitantes en clientes. Ideales para proyectar profesionalismo y captar prospectos.
            </p>
          </ColumnBox>

          <ColumnBox>
            <figure className='image'>
              <img className='skill-icon' src={IconoBackend} alt='Sistemas a la Medida' />
            </figure>
            <AboutTitle>
              Sistemas y Software a la Medida
            </AboutTitle>
            <p>
              Automatización de procesos, paneles de administración y plataformas web robustas diseñadas exactamente para las necesidades operativas de tu empresa.
            </p>
          </ColumnBox>

          <ColumnBox>
            <figure className='image'>
              <img className='skill-icon' src={IconoWordpress} alt='Desarrollo Móvil' />
            </figure>
            <AboutTitle>
              Desarrollo de Aplicaciones Móviles
            </AboutTitle>
            <p>
              Creación de aplicaciones para iOS y Android intuitivas y funcionales, pensadas para llevar tu servicio directamente al bolsillo de tus usuarios.
            </p>
          </ColumnBox>
        </ColumnsContainer>
      </DivConocimientos>
      <Espacio />

      <TechsContainer>
        <TechsTitle>Tecnologías utilizadas</TechsTitle>

        <TechsGrid>
          <i className="devicon-angularjs-plain colored"></i>
          <i className="devicon-astro-plain colored"></i>
          <i className="devicon-cloudflare-plain colored"></i>
          <i className="devicon-css3-plain colored"></i>
          <i className="devicon-docker-plain colored"></i>
          <i className="devicon-express-original colored"></i>
          <i className="devicon-firebase-plain colored"></i>
          <i className="devicon-git-plain colored"></i>
          <i className="devicon-github-original colored"></i>
          <i className="devicon-gitlab-plain colored"></i>
          <i className="devicon-graphql-plain colored"></i>
          <i className="devicon-html5-plain colored"></i>
          <i className="devicon-ionic-original colored"></i>
          <i className="devicon-javascript-plain colored"></i>
          <i className="devicon-linux-plain colored"></i>
          <i className="devicon-mariadb-original colored"></i>
          <i className="devicon-mongodb-plain colored"></i>
          <i className="devicon-mysql-original colored"></i>
          <i className="devicon-nestjs-original colored"></i>
          <i className="devicon-ngrx-plain colored"></i>
          <i className="devicon-nginx-original colored"></i>
          <i className="devicon-nodejs-plain colored"></i>
          <i className="devicon-php-plain colored"></i>
          <i className="devicon-postman-plain colored"></i>
          <i className="devicon-react-original colored"></i>
          <i className="devicon-rxjs-plain colored"></i>
          <i className="devicon-socketio-original colored"></i>
          <i className="devicon-typescript-plain colored"></i>
          <i className="devicon-woocommerce-plain colored"></i>
          <i className="devicon-wordpress-plain colored"></i>
        </TechsGrid>
      </TechsContainer>
    </AcercaDe>
  );
}

export default About;